import { useCalendlyConnection } from '../../hooks/useCalendlyConnection';

export default function CalendlyConnect() {
  const { isConnected, calendlyUserUri, loading, connectCalendly, disconnectCalendly } = useCalendlyConnection();

  if (loading) {
    return (
      <div className="glass p-7 max-w-2xl">
        <h2 className="font-heading text-xl text-vault-navy mb-5">Calendly Integration</h2>
        <div className="text-sm text-gray-400">Checking connection...</div>
      </div>
    );
  }

  return (
    <div className="glass p-7 max-w-2xl">
      <h2 className="font-heading text-xl text-vault-navy mb-5">Calendly Integration</h2>

      {isConnected ? (
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm font-medium">
              <span className="w-2 h-2 rounded-full bg-emerald-500" />
              Connected
            </span>
          </div>

          {calendlyUserUri && (
            <div>
              <label className="block text-[12px] font-semibold text-gray-400 uppercase tracking-wider">Calendly Account</label>
              <div className="text-vault-navy text-sm mt-1 font-medium break-all">{calendlyUserUri}</div>
            </div>
          )}

          <button
            onClick={disconnectCalendly}
            className="mt-2 px-5 py-2.5 rounded-btn text-sm font-semibold text-vault-error border border-vault-error/30 hover:bg-red-50 transition-colors"
          >
            Disconnect Calendly
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          <p className="text-sm text-gray-500">
            Connect your Calendly account to enable scheduling features within PlayVentr.
          </p>

          <button
            onClick={connectCalendly}
            className="px-6 py-2.5 rounded-btn text-sm font-semibold text-white shadow-btn transition-all hover:shadow-lg"
            style={{ background: 'linear-gradient(135deg, #c9a84c, #F59E0B)' }}
          >
            Connect Calendly
          </button>

          <p className="text-[11px] text-gray-400 italic">
            Requires Calendly Standard plan or above
          </p>
        </div>
      )}
    </div>
  );
}
